import {RoomService, SettingService} from '../services';
import {bindLoading} from './index';

export default {
    namespaced: true,
    state: {
        sys: {},
        months: [],
        rooms: [],
        ncutRooms: [],
        periods:[],
        mails: [],
        viewContent:{},
    },
    mutations: {
        saveSys(current, sys) {
            current.sys = sys;
        },
        saveViewContent(current, viewContent) {
            current.viewContent = viewContent;
        },
        saveMonths(current, months) {
            current.months.splice(0);
            current.months = [...months];
        },

        saveMails(current, mails) {
            current.mails.splice(0);
            current.mails = [...mails];
        },

        saveRooms(current, rooms) {
            current.rooms.splice(0);
            current.rooms.push(...rooms);
        },
        saveNcutRooms(current, rooms) {
            current.ncutRooms.splice(0);
            current.ncutRooms.push(...rooms);
        }
    },
    actions: {
        async getSysAction({dispatch, commit}) {
            await bindLoading(commit, async () => commit('saveSys', await SettingService.getSys()), 'setting')
        },

        async getViewContentAction({dispatch, commit}) {
            await bindLoading(commit, async () => commit('saveViewContent', await SettingService.getViewContent()), 'setting')
        },

        async getMonthsAction({dispatch, commit}) {
            await bindLoading(commit, async () => commit('saveMonths', await SettingService.getMonthSettings()), 'setting')
        },

        async getMailsAction({dispatch, commit}) {
            await bindLoading(commit, async () => commit('saveMails', await SettingService.getMails()), 'setting')
        },

        async saveSysAction({dispatch, commit}, sys) {
            return await bindLoading(commit, async () => {
                const result = await SettingService.updateSys(sys);
                if (result.success) {
                    commit('saveSys', sys);
                }
                return result;
            }, 'setting');

        },

        async saveViewContentAction({dispatch, commit}, view) {
            return await bindLoading(commit, async () => {
                const result = await SettingService.updateViewContent(view);
                if (result.success) {
                    commit('saveViewContent', view);
                }
                return result;
            }, 'setting');

        },

        async updateMonthAction({dispatch, commit, state}, month) {
            return await bindLoading(commit, async () => {
                const result = await SettingService.updateMonth(month);
                if (result.success) {
                    const newMonths = [...state.months.filter(m => m.id !== month.id), {...month}]
                        .sort((a, b) => b.month - a.month);
                    commit('saveMonths', newMonths);
                }
                return result;
            }, 'setting');

        },

        async insertMonthAction({dispatch, commit, state}, month) {
            return await bindLoading(commit, async () => {

                const result = await SettingService.insertMonth({...month});

                if (result.success) {
                    const newMonths = [result.instance, ...state.months];
                    commit('saveMonths', newMonths);
                }
                return result;
            }, 'setting');

        },

        async deleteMonthAction({dispatch, commit, state}, id) {
            return await bindLoading(commit, async () => {

                const result = await SettingService.deleteMonth(id);

                if (result.success) {
                    const newMonths = [...state.months.filter(m => m.id !== id)];
                    commit('saveMonths', newMonths);
                }
                return result;
            }, 'setting');

        },

        async getRoomsAction({dispatch, commit}) {
            await bindLoading(commit, async () => commit('saveRooms', await RoomService.getRooms()), 'setting');
        },

        async getNcutRoomsAction({dispatch, commit}) {
            await bindLoading(commit, async () => commit('saveNcutRooms', await RoomService.getNcutRooms()), 'setting');
        },

        async updateRoomAction({dispatch, commit, state}, room) {
            return await bindLoading(commit, async () => {
                const result = await SettingService.updateRoom(room);
                if (result.success) {
                    const newRooms = [...state.rooms.filter(r => r.id !== room.id), {...room}]
                        .sort((a, b) => a.id - b.id);
                    commit('saveRooms', newRooms);
                }
                return result;
            }, 'setting');

        },
        async insertRoomAction({dispatch, commit, state}, room) {
            return await bindLoading(commit, async () => {

                const result = await SettingService.insertRoom({...room});

                if (result.success) {
                    const newRooms = [...state.rooms, result.instance];
                    commit('saveRooms', newRooms);
                }
                return result;
            }, 'setting');

        },
        async deleteRoomAction({dispatch, commit, state}, id) {
            return await bindLoading(commit, async () => {

                const result = await SettingService.deleteRoom(id);

                if (result.success) {
                    const newRooms = [...state.rooms.filter(r => r.id !== id)];
                    commit('saveRooms', newRooms);
                }
                return result;
            }, 'setting');

        },
        async updateMailAction({dispatch, commit, state}, mail) {
            return await bindLoading(commit, async () => {
                const result = await SettingService.updateMail(mail);
                if (result.success) {
                    const newMails = [...state.mails.filter(m => m.type !== mail.type), {...mail}];
                    commit('saveMails', newMails);
                }
                return result;
            }, 'setting');

        },
    }
}